module.exports = __webpack_public_path__ + "static/tpp-icon-lens-ff7287f72c833259fff241b422b26a13.png";